// components/invoices/InvoicesFilterBar.js
import React from 'react';
import CustomerSearch from './CustomerSearch';
import styles from './Invoices.module.css';

const InvoicesFilterBar = ({ 
  activeFilter, 
  setActiveFilter, 
  selectedCustomer, 
  setSelectedCustomer,
  jewellerId 
}) => {
  const filterOptions = ['All', 'Open', 'Overdue', 'Paid'];

  return (
    <div className={styles.filterContainer}>
      <div className={styles.filterContent}>
        <div className={styles.filterButtons}>
          {filterOptions.map((filter) => (
            <button
              key={filter}
              onClick={() => setActiveFilter(filter)}
              className={`${styles.filterBtn} ${activeFilter === filter ? styles.filterBtnActive : ''}`}
            >
              {filter}
            </button>
          ))}
        </div>
        
        <CustomerSearch 
          selectedCustomer={selectedCustomer}
          setSelectedCustomer={setSelectedCustomer}
          jewellerId={jewellerId}
        />
      </div>
    </div>
  );
};

export default InvoicesFilterBar;